function onYouTubeIframeAPIReady() {
  Youtube.render();
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

const Youtube = {
  init() {

    if ($(".video-wrap").length) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  },

  render() {

    $(".video-wrap .video").each(function () {
      var toggle = $(this).closest(".video-wrap").find(".video-toggle");
      var player;
      let videoId = $(this).attr("id");

      player = new YT.Player(videoId, {
        videoId: videoId,
        width: 560,
        height: 316,
        playerVars: {
          autoplay: 0,
          controls: 1,
          modestbranding: 1,
          start: 0,
          rel: 0,
          fs: 0,
          cc_load_policy: 0,
          iv_load_policy: 3,
        },
        events: {
          onReady: function (e) {
            toggle.parent().addClass("ready");
            player.seekTo(0).stopVideo();
            // Fitvids
            player.seekTo(0).stopVideo();
            toggle.click(function () {
              player.seekTo(0).playVideo();
              toggle.parent().addClass("playing");
            });
            toggle
              .closest(".video-wrap")
              .find(".video-close")
              .click(function () {
                toggle.parent().removeClass("playing");
                setTimeout(function () {
                  player.stopVideo();
                }, 600);
              });
            $(document).keyup(function (e) {
              if (e.key === "Escape" && toggle.parent().hasClass("playing")) {
                toggle.parent().removeClass("playing");
                setTimeout(function () {
                  player.stopVideo();
                }, 600);
              }
            });
          },
        },
      });
    });
  },
};

export default Youtube;
